<template>
  <el-dialog
    v-model="dialogVisible"
    :title="title"
    :width="width"
    :close-on-click-modal="closeOnClickModal"
    :close-on-press-escape="closeOnPressEscape"
    :show-close="showClose"
    :destroy-on-close="destroyOnClose"
    @close="handleClose"
  >
    <div class="confirm-content">
      <div v-if="icon" class="confirm-icon">
        <el-icon :size="iconSize" :color="iconColor">
          <component :is="icon" />
        </el-icon>
      </div>
      <div class="confirm-message">
        <div class="confirm-title" v-if="messageTitle">{{ messageTitle }}</div>
        <div class="confirm-text">{{ message }}</div>
        <slot></slot>
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="handleCancel" :disabled="loading">{{ cancelText }}</el-button>
        <el-button
          :type="confirmType"
          @click="handleConfirm"
          :loading="loading"
        >
          {{ confirmText }}
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, watch } from 'vue';
import { Warning, Delete, InfoFilled, QuestionFilled } from '@element-plus/icons-vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: '确认'
  },
  message: {
    type: String,
    default: '确认执行此操作吗？'
  },
  messageTitle: {
    type: String,
    default: ''
  },
  confirmText: {
    type: String,
    default: '确认'
  },
  cancelText: {
    type: String,
    default: '取消'
  },
  confirmType: {
    type: String,
    default: 'primary',
    validator: (value) => ['primary', 'success', 'warning', 'danger', 'info'].includes(value)
  },
  width: {
    type: String,
    default: '420px'
  },
  closeOnClickModal: {
    type: Boolean,
    default: false
  },
  closeOnPressEscape: {
    type: Boolean,
    default: true
  },
  showClose: {
    type: Boolean,
    default: true
  },
  destroyOnClose: {
    type: Boolean,
    default: true
  },
  icon: {
    type: [String, Object],
    default: 'QuestionFilled'
  },
  iconSize: {
    type: [String, Number],
    default: 24
  },
  iconColor: {
    type: String,
    default: ''
  },
  loading: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:modelValue', 'confirm', 'cancel', 'close']);

const dialogVisible = ref(props.modelValue);

// 监听modelValue变化
watch(() => props.modelValue, (newVal) => {
  dialogVisible.value = newVal;
});

// 监听对话框可见性变化
watch(dialogVisible, (newVal) => {
  emit('update:modelValue', newVal);
});

// 处理确认
const handleConfirm = () => {
  emit('confirm');
};

// 处理取消
const handleCancel = () => {
  dialogVisible.value = false;
  emit('cancel');
};

// 处理关闭
const handleClose = () => {
  emit('close');
};
</script>

<style scoped>
.confirm-content {
  display: flex;
  align-items: flex-start;
  padding: 10px 0;
}

.confirm-icon {
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.confirm-message {
  flex: 1;
}

.confirm-title {
  font-weight: bold;
  margin-bottom: 8px;
  font-size: 16px;
}

.confirm-text {
  color: #606266;
  line-height: 1.5;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style> 